const bg_elements = document.querySelector(".bg_elements");
const elems = Array.from(bg_elements.querySelectorAll(".elem"));

let user_clicked = false;
let order = [];
let index = 0;

function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

function clear_hovered() {
    elems.forEach((e) => e.classList.remove("is_hovered"));
    bg_elements.classList.remove("have_hovered_elem");
}

// Hover + click logic
elems.forEach((elem) => {
    elem.addEventListener("mouseenter", () => {
        if (user_clicked) return;
        clear_hovered();
        bg_elements.classList.add("have_hovered_elem");
        elem.classList.add("is_hovered");
    });

    elem.addEventListener("mouseleave", () => {
        if (!user_clicked) clear_hovered();
    });

    elem.addEventListener("click", () => {
        user_clicked = true;
        clear_hovered();
        bg_elements.classList.add("have_hovered_elem");
        elem.classList.add("is_hovered");
    });
});

// Pre-build order
order = shuffle([...elems]);
index = 0;

function next_hover() {
    if (user_clicked) return;

    clear_hovered();

    const elem = order[index];
    bg_elements.classList.add("have_hovered_elem");
    elem.classList.add("is_hovered");

    index++;
    if (index >= order.length) {
        order = shuffle([...elems]); // reshuffle for next cycle
        index = 0;
    }
}
next_hover();
setInterval(next_hover, 3000);
